// extracted by mini-css-extract-plugin
module.exports = {"container":"icon_container__17Kfj","loading":"icon_loading__3s6om","animation":"icon_animation__5Wcqg"};